import {Component, Input} from '@angular/core';
import moment from "moment";

@Component({
  selector: 'app-card-alerta',
  templateUrl: './card-alerta.component.html',
  styleUrls: ['./card-alerta.component.scss']
})
export class CardAlertaComponent {
 @Input() justificativa = null;
 @Input() dataPendencia = null;
  protected readonly moment = moment;
}
